<template>
    <p>
      <span class="name">{{ context_contact.name }}</span>
      <span class="email">{{ context_contact.email }}</span>
    </p>

    <ActionButton
        @click="onActionToSendMail"
        text='contacts.actions.send_mail'
        icon='fas fa-pencil-alt'
        class="clear"
    />

    <ActionButton
        text='contacts.actions.add_filter'
        @click="onActionAddFilter"
        icon='fas fa-filter'
        class="clear"
    />

    <ActionButton
        v-if="context_contact.temporary"
        @click="onSavePerson"
        text='contacts.actions.add_person'
        icon='fas fa-user-plus'
        class="clear" />

    <RouterButton
        v-if="!context_contact.temporary"
        text='contacts.actions.edit'
        icon='fas fa-user-edit'
        :link="`/contacts/person/edit/${context_contact.id}`"
        class="clear" />

    <ActionButton
        v-if="!context_contact.temporary && !disabled_actions['delete']"
        @click="onDeletePerson"
        text='contacts.actions.delete'
        icon='fas fa-trash-alt'
        class="clear" />
</template>

<script setup>
  import { useRouter }        from 'vue-router';
  import ContactsController   from '@/js/Contacts/ContactsController';
  import ActionButton         from '@/vue/Elements/Buttons/ActionButton.vue';
  import StateConsumer        from '@/js/Shared/State/StateConsumer';
  import RouterButton         from '@/vue/Elements/Buttons/RouterButton.vue';

  const props = defineProps({
    context_contact: {
        type: Object,
        required: true
    },

    disabled_actions: {
        default : {},
    }
  });

  const router = useRouter();
  const contacts_controller = ContactsController;

  const onActionAddFilter = () => {
    StateConsumer.set('filters_conditions_recipients', [props.context_contact.email]);
    router.push('/settings/filters/add');
  }

  const onSavePerson = () => {
    contacts_controller.savePerson(props.context_contact, 'contacts-added-context');
  }

  const onDeletePerson = () => {
    contacts_controller.deleteContacts([props.context_contact.id], 'contacts-deleted-context');
  }

  const onActionToSendMail = () => {
    StateConsumer.set('contacts_to_recipients', [props.context_contact]);
    router.push('/compose');
  }
</script>
